import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import { IApiResponse } from "../../../AbstractApiClient/IApiResponse";

export type TRefreshCompanyOnboardingShareableLinkTokenParams = {
  accessToken: string;
  companyID: string;
};

export type TRefreshCompanyOnboardingShareableLinkTokenResponse = {
  accessToken: string;
};

export const refreshCompanyOnboardingShareableLinkToken = (
  axios: IAxiosInstance
) => {
  return async (
    body: TRefreshCompanyOnboardingShareableLinkTokenParams
  ): Promise<TRefreshCompanyOnboardingShareableLinkTokenResponse> => {
    const response = await axios.noRetry.post<
      IApiResponse<TRefreshCompanyOnboardingShareableLinkTokenResponse>
    >("/api/refreshCompanyOnboardingShareableLinkToken", body);
    const resData = response.data;
    if (resData.success && resData.data) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
